import React from "react";
import {useTranslation} from "react-i18next";
import {Form, Formik} from "formik";
// local
import {Modal} from "components/Modal";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
import FormikField from "components/FormikField";

export const RemoveQualificationAnswersModal = ({onConfirm, onClose}) => {
  const {t} = useTranslation();

  const onSubmit = async (values) => onConfirm(values.rejectMessage);

  return (
    <Modal
      customTitle={
        <div>
          {t("REMOVE_QUALIFICATION_ANSWERS_MODAL_TITLE")}
          <div className="not-interested-message-modal__subtitle">
            {t("REMOVE_QUALIFICATION_ANSWERS_MODAL_SUBTITLE")}
          </div>
        </div>
      }
      noTitleIcon
      boldTitle
      placeBitHigh
      width={420}
      percentageWide="30%"
      rounded
      darked
      style={{marginTop: "15vh"}}
      onClose={onClose}
    >
      <div className="not-interested-message-modal__content">
        <Formik initialValues={{rejectMessage: ""}} onSubmit={onSubmit}>
          {({values}) => (
            <Form>
              <FormikField
                name="rejectMessage"
                placeholder={t("REMOVE_QUALIFICATION_ANSWERS_MODAL_PLACEHOLDER")}
                errorName="rejectMessage"
                autoSize={{maxRows: 6}}
                maxLength="1000"
                rows={6}
                addClass="mb-8"
                textarea
                textareaValue={values.rejectMessage}
              />
              <div className="df-row-jce-center ">
                <ButtonTransparent
                  name="CANCEL"
                  color="red"
                  type="button"
                  onClick={onClose}
                  addClass="mr-4"
                />
                <ButtonTransparent type="submit" name="SEND" />
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};
